import React from "react";
import { all_routes } from "../../../Router/all_routes";
import { useEffect, useState } from "react";
import CheckRestauSelected from "../../components/SessionControl/checkrestauselected";
import SessionControl from "../../components/SessionControl/sessioncontrol";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import CountUp from "react-countup";
import axios from "axios";
import { base_api_url } from "../../../environment.jsx";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";

const Statistics = () => {
  const route = all_routes;
  const MySwal = withReactContent(Swal);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  let devise = JSON.parse(localStorage.getItem("restaurant"))?.Restaurant?.devise || JSON.parse(localStorage.getItem("restaurant"))?.restaurant?.devise;
  const [numCommandMonth, setNumCommandMonth] = useState([]);
  const [numCommandDay, setNumCommandDay] = useState([]);
  const [fiveItemsMonth, setFiveItemsMonth] = useState([]);

  useEffect(() => {
    Restaurant();
    fetchtnumCommandMonth();
    fetchtnumCommandDay();
    fetchtFiveItemsMonth();
  }, []);

  const Restaurant = async () => {
    const token = JSON.parse(localStorage.getItem("user"))?.access_token;
    const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;
    const currentResto = localStorage.getItem("restaurant");
    try {
      if (!currentResto) {
        const gotResto = await axios.get(`${base_api_url}api/restaurant/${ideresto}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        localStorage.setItem("restaurant", JSON.stringify(gotResto.data));
        devise = gotResto.data.restaurant?.devise || gotResto.data.Restaurant?.devise;
      }
    } catch (error) {
      console.error("Error fetching restaurant data:", error);
    }
  };

  const fetchtnumCommandMonth = async () => {
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("user"))?.access_token;
    const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;
    try {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      let url = `${base_api_url}api/finishcommande/${ideresto}/${year}/${month}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });
      console.log("Réponse API :", response.data);

      // Handle successful responses (200, 201)
      if (response.status === 200 || response.status === 201) {
        const commandesData = response.data || [];
        setNumCommandMonth(commandesData);

        // Save user data
        localStorage.setItem("commandes", JSON.stringify(commandesData));

        // Show success notification only if tables are loaded
        if (commandesData.length <= 0) {
          // Show info notification if no tables found
          MySwal.fire({
            icon: "info",
            // title: "Aucune commande du mois",
            text: "Aucune commande trouvée pour ce restaurant. Créez votre première commande pour commencer.",
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            customClass: {
              popup: "pixel-toast",
            },
          });
        }
      }
    } catch (error) {
      console.log("Error fetching commands:", error);

      //       let errorTitle = "Erreur de chargement";
      let errorMessage = "Impossible de charger les commandes.";

      if (error.response) {
        const status = error.response.status;
        const errorData = error.response.data;

        switch (status) {
          case 401:
            //             errorTitle = "Session expirée";
            errorMessage = "Votre session a expiré. Vous allez être redirigé vers la page de connexion.";
            setTimeout(() => {
              navigate(route.signin);
            }, 2000);
            break;
          case 400:
            //             errorTitle = "Aucun mois correspondant";
            errorMessage = "Entrer un mois valide.";
            break;

          case 403:
            //             errorTitle = "Accès refusé";
            errorMessage = "Vous n'avez pas les permissions nécessaires pour accéder aux commandes.";
            break;

          case 404:
            //             errorTitle = "Restaurant introuvable";
            errorMessage = "Aucune commande trouvée pour ce restaurant ou le restaurant n'existe pas.";
            break;

          case 429:
            //             errorTitle = "Trop de tentatives";
            errorMessage = "Trop de demandes en peu de temps. Veuillez patienter quelques instants.";
            break;

          case 500:
            //             errorTitle = "Erreur du serveur";
            errorMessage = "Une erreur s'est produite sur le serveur. Veuillez actualiser la page.";
            break;

          case 503:
            //             errorTitle = "Service indisponible";
            errorMessage = "Le service est temporairement indisponible. Veuillez réessayer plus tard.";
            break;

          default:
            //             errorTitle = `Erreur ${status}`;
            errorMessage = errorData?.message || "Une erreur inattendue s'est produite lors du chargement des tables.";
        }
      } else if (error.request) {
        //         errorTitle = "Problème de connexion";
        errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
      }

      // Show error notification
      MySwal.fire({
        icon: "error",
        text: errorMessage,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });

      // Set empty array on error to prevent UI issues
      setNumCommandMonth([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchtnumCommandDay = async () => {
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("user"))?.access_token;
    const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;
    try {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      let url = `${base_api_url}api/finishcommande/${ideresto}/${year}-${month}-${day}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });
      console.log("Réponse API :", response.data);

      // Handle successful responses (200, 201)
      if (response.status === 200 || response.status === 201) {
        const commandesData = response.data || [];
        setNumCommandDay(commandesData);

        // Save user data
        localStorage.setItem("commandes", JSON.stringify(commandesData));

        // Show success notification only if tables are loaded
        if (commandesData.length <= 0) {
          // Show info notification if no tables found
          MySwal.fire({
            icon: "info",
            // title: "Aucune commandes du jour",
            text: "Aucune commande trouvée pour ce restaurant. Créez votre première commande pour commencer.",
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            customClass: {
              popup: "pixel-toast",
            },
          });
        }
      }
    } catch (error) {
      console.log("Error fetching commands:", error);

      //       let errorTitle = "Erreur de chargement";
      let errorMessage = "Impossible de charger les commandes.";

      if (error.response) {
        const status = error.response.status;
        const errorData = error.response.data;

        switch (status) {
          case 401:
            //             errorTitle = "Session expirée";
            errorMessage = "Votre session a expiré. Vous allez être redirigé vers la page de connexion.";
            setTimeout(() => {
              navigate(route.signin);
            }, 2000);
            break;
          case 400:
            //             errorTitle = "Aucun mois correspondant";
            errorMessage = "Entrer un mois valide.";
            break;

          case 403:
            //             errorTitle = "Accès refusé";
            errorMessage = "Vous n'avez pas les permissions nécessaires pour accéder aux commandes.";
            break;

          case 404:
            //             errorTitle = "Restaurant introuvable";
            errorMessage = "Aucune commande trouvée pour ce restaurant ou le restaurant n'existe pas.";
            break;

          case 429:
            //             errorTitle = "Trop de tentatives";
            errorMessage = "Trop de demandes en peu de temps. Veuillez patienter quelques instants.";
            break;

          case 500:
            //             errorTitle = "Erreur du serveur";
            errorMessage = "Une erreur s'est produite sur le serveur. Veuillez actualiser la page.";
            break;

          case 503:
            //             errorTitle = "Service indisponible";
            errorMessage = "Le service est temporairement indisponible. Veuillez réessayer plus tard.";
            break;

          default:
            //             errorTitle = `Erreur ${status}`;
            errorMessage = errorData?.message || "Une erreur inattendue s'est produite lors du chargement des tables.";
        }
      } else if (error.request) {
        //         errorTitle = "Problème de connexion";
        errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
      }

      // Show error notification
      MySwal.fire({
        icon: "error",
        text: errorMessage,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });

      // Set empty array on error to prevent UI issues
      setNumCommandDay([]);
    } finally {
      setLoading(false);
    }
  };


  const fetchtFiveItemsMonth = async () => {
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("user"))?.access_token;
    const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;
    try {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      let url = `${base_api_url}api/finishcommandes/${ideresto}/${year}/${month}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });
      console.log("Les 5 articles :", response.data);

      // Handle successful responses (200, 201)
      if (response.status === 200 || response.status === 201) {
        const commandesData = response.data || [];
        setFiveItemsMonth(commandesData);

        // Save user data
        localStorage.setItem("articles", JSON.stringify(commandesData));

        // Show success notification only if tables are loaded
        if (commandesData.length <= 0) {
          // Show info notification if no tables found
          MySwal.fire({
            icon: "info",
            // title: "Aucun article sur ce mois",
            text: "Aucun article trouvé pour ce restaurant. Créez votre première commande pour commencer.",
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            customClass: {
              popup: "pixel-toast",
            },
          });
        }
      }
    } catch (error) {
      console.log("Error fetching articles:", error);

      let errorMessage = "Impossible de charger les articles.";

      if (error.response) {
        const status = error.response.status;
        const errorData = error.response.data;

        switch (status) {
          case 401:
            //             errorTitle = "Session expirée";
            errorMessage = "Votre session a expiré. Vous allez être redirigé vers la page de connexion.";
            setTimeout(() => {
              navigate(route.signin);
            }, 2000);
            break;
          case 400:
            //             errorTitle = "Aucun mois correspondant";
            errorMessage = "Entrer un mois valide.";
            break;

          case 403:
            //             errorTitle = "Accès refusé";
            errorMessage = "Vous n'avez pas les permissions nécessaires pour accéder aux commandes.";
            break;

          case 404:
            //             errorTitle = "Restaurant introuvable";
            errorMessage = "Aucune commande trouvée pour ce restaurant ou le restaurant n'existe pas.";
            break;

          case 429:
            //             errorTitle = "Trop de tentatives";
            errorMessage = "Trop de demandes en peu de temps. Veuillez patienter quelques instants.";
            break;

          case 500:
            //             errorTitle = "Erreur du serveur";
            errorMessage = "Une erreur s'est produite sur le serveur. Veuillez actualiser la page.";
            break;

          case 503:
            //             errorTitle = "Service indisponible";
            errorMessage = "Le service est temporairement indisponible. Veuillez réessayer plus tard.";
            break;

          default:
            //             errorTitle = `Erreur ${status}`;
            errorMessage = errorData?.message || "Une erreur inattendue s'est produite lors du chargement des tables.";
        }
      } else if (error.request) {
        //         errorTitle = "Problème de connexion";
        errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
      }

      // Show error notification
      MySwal.fire({
        icon: "error",
        text: errorMessage,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });

      // Set empty array on error to prevent UI issues
      setNumCommandMonth([]);
    } finally {
      setLoading(false);
    }
  };

  console.log("Les 5 articles les plus vendus:", fiveItemsMonth);


  return (
    <div className="page-wrapper">
      <SessionControl
        storageKey="user"
        propsup="email"
        redirectTo={route.signin}
      />
      <CheckRestauSelected
        storageKey="user"
        redirectTo={route.Restaurants}
      />
      <div className="content">
        <h3>Indicateurs de performance</h3>
        {loading ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Chargement...</span>
            </div>
          </div>
        ) : (
          <div className="row mt-4">
            <h3 style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#333',
              margin: 0,
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>Jour</h3>
            <div className="col-xl-6 col-sm-6 col-lg-6 d-flex mt-2">
              <div className="dash-widget w-100">
                <div className="dash-widgetimg">
                  <span>
                    <ImageWithBasePath
                      src="assets/img/icons/dash1.svg"
                      alt="img"
                    />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    <CountUp
                      start={0}
                      end={numCommandDay?.total_des_ventes || 0}
                      duration={3}
                      suffix={devise}
                    />
                  </h5>
                  <h6>Chiffre d&apos;affaires du jour </h6>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-sm-6 col-lg-6 d-flex mt-2">
              <div className="dash-widget dash1 w-100">
                <div className="dash-widgetimg">
                  <span>
                    <ImageWithBasePath
                      src="assets/img/icons/dash2.svg"
                      alt="img"
                    />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    <CountUp
                      start={0}
                      end={numCommandDay?.nombre_articles || 0}
                      duration={3} // Duration in seconds
                    />
                  </h5>
                  <h6>Nombre de plat vendu</h6>
                </div>
              </div>
            </div>
            <h3 style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#333',
              margin: 0,
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>Mois</h3>
            <div className="col-xl-6 col-sm-6 col-lg-6 col-12 d-flex mt-2">
              <div className="dash-widget dash2 w-100">
                <div className="dash-widgetimg">
                  <span>
                    <ImageWithBasePath
                      src="assets/img/icons/dash3.svg"
                      alt="img"
                    />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    <CountUp
                      start={0}
                      end={numCommandMonth?.total_des_ventes || 0}
                      duration={3} // Duration in seconds
                      decimals={1}
                      suffix={devise}
                    />
                  </h5>
                  <h6>Chiffre d&apos;affaires du mois</h6>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-sm-6 col-lg-6 col-12 d-flex mt-2">
              <div className="dash-widget dash3 w-100">
                <div className="dash-widgetimg">
                  <span>
                    <ImageWithBasePath
                      src="assets/img/icons/dash4.svg"
                      alt="img"
                    />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    <CountUp
                      start={0}
                      end={numCommandMonth?.nombre_articles || 0}
                      duration={3} // Duration in seconds
                    />
                  </h5>
                  <h6>Nombre de plat vendu</h6>
                </div>
              </div>
            </div>
            <div className="col-xl-12 col-sm-12 col-12 d-flex">
              <div className="card flex-fill default-cover mb-4">
                <div className="card-header d-flex align-items-center gap-4"
                  style={{ display: 'flex !important', justifyContent: 'flex-start' }}
                >
                  <span
                    style={{ backgroundColor: '#a1a1a1ff', borderRadius: '50%', padding: '10px', width: '50px', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/total-sales.svg"
                      alt="img"
                    />
                  </span>
                  <h5 className="card-title">les 5 articles les plus vendus</h5>
                </div>
                <div className="card-body">
                  <div className="table-responsive dataview">
                    <table className="table dashboard-recent-products">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Articles</th>
                          <th>Quantité</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <div className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                              <span className="sr-only">Chargement...</span>
                            </div>
                          </div>
                        ) : fiveItemsMonth.length === 0 ? (
                          <tr>
                            <td colSpan="3" className="text-center">Aucun article trouvé</td>
                          </tr>
                        ) : (
                          fiveItemsMonth.map((item, index) => (
                            <tr key={item.id}>
                              <td>
                                <h5>{index + 1}</h5>
                              </td>
                              <td className="productimgname">
                                <img
                                  style={{ borderRadius: '8%', width: '50px', height: '50px', objectFit: "cover" }}
                                  src={item.image_url && !item.image_url.startsWith('data:image') ? `${base_api_url}api/recuperer/${item.image_url}` : item.image_url}
                                  alt="product"
                                />
                                {item.nom}
                              </td>
                              <td>{item.quantite}</td>
                            </tr>
                          )))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Statistics;
